import { useTheme } from "../../ThemeContext";
import { getBudgetCardColors } from "../budget/budgetPalette";

// Theme-aware colours shared by every utilisation component.
export const useUtilisationColors = () => {
  const { isDarkMode } = useTheme();
  return getBudgetCardColors(isDarkMode);
};

// "ok" = on track (teal), "over" = exceeded / missed (red).
export const toneColors = (colors, tone) =>
  tone === "over"
    ? { main: colors.red, wash: colors.redWash }
    : { main: colors.teal, wash: colors.tealWash };

export default useUtilisationColors;
